var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.677 7.97a5.343 5.343 0 0 1-1.405 3.16c.2.43.44.801.552 1.21.343 1.253-.548 2.578-1.867 2.84-1.32.262-2.67-.613-2.847-1.906-.044-.31.082-.665.205-.97.18-.446.426-.862.814-1.184a.34.34 0 0 0 .064-.326c-.077-.149-.237-.106-.363-.02-.445.317-.733.75-.918 1.247-.081.201-.134.412-.158.627-.016.2-.122.23-.273.206a6.679 6.679 0 0 1-.844-.15c-2.173-.592-3.753-2.424-3.981-4.615a5.315 5.315 0 0 1 .191-2.09c.045-.15.126-.191.273-.218.522-.096.979-.315 1.29-.753.122-.17.21-.362.05-.62-.103.107-.191.193-.273.284-.28.317-.572.613-1.007.729a1.296 1.296 0 0 1-1.056-.138 2.44 2.44 0 0 1-1.097-2.8C1.351 1.413 2.369.691 3.51.72c1.102.027 1.966.635 2.354 1.653.02.051.045.1.056.124.508-.117.995-.255 1.492-.338a5.106 5.106 0 0 1 2.424.21c.166.052.255.03.37-.106.816-.98 1.884-1.397 3.156-1.198 1.346.214 2.24.996 2.672 2.262.203.593.151 1.19.047 1.8-.17.979-.767 1.625-1.61 2.073-.683.365-1.436.345-2.178.189-.17-.036-.315-.187-.478-.271a1.07 1.07 0 0 0-.253-.062c-.001.087-.05.213-.003.256.173.173.352.364.57.47.4.19.85.259 1.292.197.069-.008.142-.004.256-.009Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28 3.125c-.018 1.606 1.31 2.524 1.977 2.783.5.173 1.2.364.002-.251-1.197-.616-1.651-1.943-1.728-2.53-.077-.67-.233-1.609-.251-.002Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFat);
export default __webpack_public_path__ + "static/media/fat.91ef07b087270e95411ce5a1abc9dd39.svg";
export { ForwardRef as ReactComponent };